import { useEffect } from "react";

export function useClickOutside(ref, handler) {
  
  useEffect(() => {
    function listener(event) {
      // Se não tem ref ou clique foi dentro do container, ignora
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event); // clique fora - dispara handler
    }

    function handleEsc(event) {
      if (event.key === "Escape") {
        handler(event); // tecla Esc - dispara handler
      }
    }

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener); // mobile
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [ref, handler]);
}
